﻿import "@fiqas/utils"
import { IIdentityLink } from "../interfaces/iFqs";
import { CaseType } from "./serviceCase";

export interface ReportCollection {
    id: IIdentityLink,
    desc: string,
    value: any,
    items: ReportCollectionItem[],
    records: IIdentityLink,
    _curies: { name: string, href: string }[],
}

export interface ReportCollectionItem {
    desc: string,
    value: any,
    items?: ReportCollectionItem[],
    records?: IIdentityLink,
}

export type ReportAngle = string;
export type ReportType = "active" | "project" | "historic" | "balance";
export type ReportPeriod = "year" | "month" | "week" | "day";
export type CaseState = "new" | "closed" | "all";
export type BalanceCaseType = "request" | "bug" | "all";

export interface ReportParameters {
    reportType?: ReportType;
    angle: ReportAngle;
    projectTreeOfNumber: string;
    from?: ISODateString;
    until?: ISODateString;
    cid: number[];
    caseType: CaseType[];
    activeCasesOnly: boolean;
}
export interface BalanceReportParameters {
    from?: ISODateString;
    until?: ISODateString;
    caseType: BalanceCaseType;
    period: ReportPeriod;
    caseState: CaseState;
    cid: number[];
}
